import React from 'react'
// import first from "../../Images/MainCarousel/first.jpg"
import g1 from "../../Images/infra/g1.jpg"
import g2 from "../../Images/infra/g2.jpg"
import g3 from "../../Images/infra/g3.jpg"
import g4 from "../../Images/infra/g4.jpg"
import g5 from "../../Images/infra/g5.jpg"
import g6 from "../../Images/infra/g6.jpg"
import g7 from "../../Images/infra/g7.jpg"
import g8 from "../../Images/infra/g8.jpg"
import g9 from "../../Images/infra/g9.jpg"

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

function Plant() {
    return (
     
<div className="section">
{/* <div className="content-wrap"> */}
<div className="container">

<div className="row pb-3">
	<div className="col-sm-12 col-md-12 pleft">
		<div className="single-page">
			<h3 className="text-primary text-center ">
			Plant Infrastructure
			</h3>
		</div>
	</div>
</div>


<div className="row pb-3">
	<div className="col-sm-12 col-md-12 pleft">
		<div className="single-page">
			<h4 className="text-primary text-center uk21">
			Images
			</h4>
		</div>
	</div>
</div>



<SimpleReactLightbox>   
   <SRLWrapper>
<div className="row">

  
               
<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g1} title="Industrial Complex">
            <div className="media-img">
                <img src={g1} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>

<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g9} title="Industrial Complex">
            <div className="media-img">
                <img src={g9} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>

</div>

</SRLWrapper>
</SimpleReactLightbox>


<div className="row pb-3">
	<div className="col-sm-12 col-md-12 pleft">
		<div className="single-page">
			<h4 className="text-primary text-center uk21">
			Production
			</h4>
		</div>
	</div>
</div>



<SimpleReactLightbox>   
   <SRLWrapper>
<div className="row">

<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g2} title="Industrial Complex">
            <div className="media-img">
                <img src={g2} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>

<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g3} title="Industrial Complex">
            <div className="media-img">
                <img src={g3} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>	
</div>


<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g5} title="Industrial Complex">
            <div className="media-img">
                <img src={g5} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>

<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g8} title="Industrial Complex">
            <div className="media-img">
                <img src={g8} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>

</div>

</SRLWrapper>
</SimpleReactLightbox>


<div className="row pb-3">
	<div className="col-sm-12 col-md-12 pleft">
		<div className="single-page">
			<h4 className="text-primary text-center uk21">
			Quality
			</h4>
		</div>
	</div>
</div>



<SimpleReactLightbox>   
   <SRLWrapper>
<div className="row">






<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g4} title="Industrial Complex">
            <div className="media-img">
                <img src={g4} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>



<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g6} title="Industrial Complex">
            <div className="media-img">
                <img src={g6} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>	
</div>


<div className="col-sm-4 col-md-4">
    <div className="box-image-1">
        <a href={g7} title="Industrial Complex">
            <div className="media-img">
                <img src={g7} alt="" className="img-fluid" />
            </div>
            {/* <div className="body-content">
                <h4 className="title">Commercial Building</h4>
                <p className="category">building, design</p>
            </div> */}
        </a>
    </div>
</div>







</div>

    </SRLWrapper>
</SimpleReactLightbox>


</div>
{/* </div> */}
</div> 


        
    )
}

export default Plant
